import * as React from 'react';
export const signOutSvg = React.forwardRef(function signOutSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M3.75 1A2.75 2.75 0 0 0 1 3.75v8.5A2.75 2.75 0 0 0 3.75 15H8a.75.75 0 0 0 0-1.5H3.75c-.69 0-1.25-.56-1.25-1.25v-8.5c0-.69.56-1.25 1.25-1.25H8A.75.75 0 0 0 8 1H3.75Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M12.03 3.97a.75.75 0 1 0-1.06 1.06l2.22 2.22H6a.75.75 0 0 0 0 1.5h7.19l-2.22 2.22a.75.75 0 1 0 1.06 1.06l3.5-3.5a.75.75 0 0 0 0-1.06l-3.5-3.5Z',
    }),
  );
});
signOutSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var signOut = {
  category: 'icon',
  colorable: true,
  name: 'signOut',
  svg: signOutSvg,
};
